export const featureRowDataHooks = {
  row: 'feature-row',
  header: 'feature-row-header',
  cell: 'feature-row-cell',
  name: 'feature-row-name',
  tooltip: 'feature-row-tooltip',
  tooltipIcon: 'feature-row-tooltip-icon',
  benefit: 'feature-row-benefit',
  newBadge: 'feature-row-new-badge',
  nameAndDisclaimer: 'feature-row-name-and-disclaimer',
  nameAndNewBadge: 'feature-row-name-and-new-badge',

  truncatedDomainName: 'truncated-domain-name',
  voucherDisclaimer: 'voucher-disclaimer',
};
